export default abstract class Model {

	public id!: string;

}
